import React from 'react';
import {connect} from 'react-redux';
import {Panel} from 'react-bootstrap';
import {FormErrors} from '../common';
import {SecondaryNavigation} from '../Navigation';
import ParentReaderAssociationForm from './ParentReaderAssociationForm';
import {associateParentAndReader} from 'api/users';
import {addFlashMessage} from 'actions/flash-message';
import {formatErrors} from 'actions/errors';

class ParentReaderAssociation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      formKey: 0,
    };
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  handleFormSubmit(data) {
    const {formatErrors, addFlashMessage} = this.props;
    return associateParentAndReader({
      parentId: data.parent.id,
      readerId: data.reader.id,
    })
      .then(() => {
        addFlashMessage('Parent and student are successfully linked!', 'success');
        this.setState((prevState) => ({
          formKey: prevState.formKey + 1,
        }));
      })
      .catch((err) =>
        formatErrors(err).then((err) => {
          this.setState({
            errors: err,
          });
        }),
      );
  }

  render() {
    const {errors, formKey} = this.state;
    return (
      <React.Fragment>
        <SecondaryNavigation
          tabs={[
            {url: '/users', label: 'Users', isActive: false},
            {url: '/users/invitations', label: 'Invitations', isActive: false},
            // {url: '/users/parent-student-association', label: 'Link Parent and Student', isActive: true},
          ]}
        />
        <div className="container content-box">
          <Panel>
            <FormErrors errors={errors} />
            <ParentReaderAssociationForm key={formKey} onSubmit={this.handleFormSubmit} />
          </Panel>
        </div>
      </React.Fragment>
    );
  }
}

export default connect(null, {
  formatErrors,
  addFlashMessage,
})(ParentReaderAssociation);
